module.exports = __webpack_public_path__ + "static/media/ico-confirm-modal.019db8e3.svg";